module.exports = __webpack_public_path__ + "static/media/2.211a9cd6.jpg";